import { render, staticRenderFns } from "./PageDesigner.vue?vue&type=template&id=fc6ff420"
import script from "./PageDesigner.vue?vue&type=script&lang=js"
export * from "./PageDesigner.vue?vue&type=script&lang=js"
import style0 from "./PageDesigner.vue?vue&type=style&index=0&id=fc6ff420&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports